// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"405":"81330660780ace40","817":"033afa65dfc0070e","888":"2c16774a1e3b4437"}[chunkId] + ".css";
};